import { render, staticRenderFns } from "./CourceModelsDayAddButton.vue?vue&type=template&id=56d3c46a&scoped=true"
import script from "./CourceModelsDayAddButton.vue?vue&type=script&lang=js"
export * from "./CourceModelsDayAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3c46a",
  null
  
)

export default component.exports